<form [formGroup]="form" class="app-modal-form">
  <div class="modal-topbar">
    <h5 class="modal-title" translate>OPPROTUNITIES.OPPORTUNITY</h5>
    <div class="modal-actions">
      <button pButton type="button" icon="pi pi-window-maximize"
              class="p-button-text p-button-rounded p-button-plain"
              onclick="const d=this.closest('.p-dialog'); if(d){d.classList.toggle('app-dialog-maximized');}"></button>
      <button pButton type="button" icon="pi pi-times"
              class="p-button-text p-button-rounded p-button-plain"
              (click)="close()"></button>
    </div>
  </div>

  <div class="p-fluid formgrid grid">
    <div class="field col-12 md:col-4">
      <label for="periodOfPotentialDeal" class="required-mark" translate>OPPORTUNITIES.DATE_REALIZATION</label>
      <p-calendar id="periodOfPotentialDeal"
                  formControlName="periodOfPotentialDeal"
                  appendTo="body"
                  dateFormat="dd.mm.yy"></p-calendar>
    </div>
    <div class="field col-12 md:col-4">
      <label for="customer" class="required-mark" translate>OFFER.CUSTOMER</label>
      <p-autoComplete formControlName="customer"
                      [suggestions]="filtered"
                      (completeMethod)="filterCustomers($event)"
                      [dropdown]="true"
                      forceSelection="true"
                      appendTo="body"
                      id="customer"
                      field="name">
      </p-autoComplete>
    </div>
    <div class="field col-12 md:col-4">
      <label for="frequency" translate>COMMON.FREQUENCY</label>
      <p-autoComplete formControlName="frequency"
                      [suggestions]="filtered"
                      (completeMethod)="filterCodelist($event, 'codelists/frequencies')"
                      [dropdown]="true"
                      forceSelection="true"
                      appendTo="body"
                      id="frequency"
                      field="name">
      </p-autoComplete>
    </div>
    <div class="field col-12 md:col-8">
      <label for="description" translate>PRODUCT.DESCRIPTION</label>
      <textarea id="description" pInputTextarea rows="4" formControlName="description"></textarea>
    </div>
    <div class="field col-12 md:col-4">
      <label for="probability" translate>COMMON.PROBABILITY</label>
      <p-autoComplete formControlName="probability"
                      [suggestions]="filtered"
                      (completeMethod)="filterCodelist($event, 'codelists/probabilities')"
                      [dropdown]="true"
                      forceSelection="true"
                      appendTo="body"
                      id="probability"
                      field="name">
      </p-autoComplete>
    </div>
    <div class="field col-12 md:col-4">
      <label for="productGroup" class="required-mark" translate>COMMON.PRODUCT_GROUP</label>
      <p-autoComplete formControlName="productGroup"
                      [suggestions]="filtered"
                      (completeMethod)="filterCodelist($event, 'codelists/productGroups')"
                      (onSelect)="clearProducts()"
                      (onClear)="clearProducts()"
                      [dropdown]="true"
                      type="search"
                      forceSelection="true"
                      appendTo="body"
                      id="productGroup"
                      field="name">
      </p-autoComplete>
    </div>
    <div class="field col-12 md:col-4">
      <label for="product" translate>COMMON.PRODUCT</label>
      <p-autoComplete formControlName="product"
                      [suggestions]="filtered"
                      (completeMethod)="filterProducts($event, form.get('productGroup').value != null ? form.get('productGroup').value.id : null)"
                      [dropdown]="true"
                      forceSelection="true"
                      appendTo="body"
                      id="product"
                      field="description">
      </p-autoComplete>
    </div>
    <div class="field col-12 md:col-4">
      <label for="status" translate>COMMON.STATUS</label>
      <p-autoComplete formControlName="status"
                      [suggestions]="filtered"
                      (completeMethod)="filterCodelist($event, 'codelists/statuses')"
                      [dropdown]="true"
                      forceSelection="true"
                      appendTo="body"
                      id="status"
                      field="name">
      </p-autoComplete>
    </div>
    <div class="field col-12 md:col-4">
      <label for="volume" translate>OFFER.QUANTITY</label>
      <input id="volume" type="number" pInputText formControlName="volume">
    </div>
    <div class="field col-12 md:col-4">
      <label for="volumeUnit" translate>COMMON.UNIT</label>
      <p-autoComplete formControlName="volumeUnit"
                      [suggestions]="filtered"
                      (completeMethod)="filterCodelist($event, 'codelists/units')"
                      [dropdown]="true"
                      forceSelection="true"
                      appendTo="body"
                      id="volumeUnit"
                      field="name">
      </p-autoComplete>
    </div>
    <div class="field col-12 md:col-4">
      <label for="stage" translate>COMMON.STAGE</label>
      <p-autoComplete formControlName="stage"
                      [suggestions]="filtered"
                      (completeMethod)="filterCodelist($event, 'codelists/stages')"
                      [dropdown]="true"
                      forceSelection="true"
                      appendTo="body"
                      id="stage"
                      field="name">
      </p-autoComplete>
    </div>
    <div class="field col-12 md:col-4">
      <label for="value" translate>COMMON.VALUE</label>
      <input id="value" type="number" pInputText formControlName="value">
    </div>
  </div>

  <div class="modal-footer">
    <p-button icon="pi pi-check" class="p-button-raised" styleClass="p-button-success" (click)="save()"
              [disabled]="form.invalid"
              [label]="'BUTTON.SAVE' | translate"></p-button>
  </div>
</form>
